import * as urlUtils from 'utils/url';
import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/survey_templates/:id/reports`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class CategoryReportApi {
  /**
   * Gets all survey template report.
   * If the parameters from and to are provided then the reports are filtered according to the timestamp.
   *
   * @param {int} categoryId
   * @param {int} from Unix timestamp
   * @param {int} to Unix timestamp
   */
  static getAll(categoryId, from, to) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, categoryId);

    return AuthenticatedRequestService.get(
      urlUtils.addQueryParameters(INDEX_URL, { from, to })
    );
  }
}

export default CategoryReportApi;



// WEBPACK FOOTER //
// ./src/apis/reports/CategoryReport.js